import React from 'react';
import { Copy } from 'lucide-react';
import { clsx } from 'clsx';

type Props = {
    value: string;
    onCopy: (value: string, event: React.MouseEvent) => void;
    label?: string;
    className?: string;
    /** When true, hidden until parent group is hovered or focused-within. */
    revealOnGroup?: boolean;
    /** Named Tailwind group on parent, e.g. "group/id" → hover classes use group-hover/id: */
    parentGroup?: string;
};

export const CopyIconButton: React.FC<Props> = ({
    value,
    onCopy,
    label,
    className,
    revealOnGroup = true,
    parentGroup = 'group',
}) => {
    const hoverPrefix = parentGroup === 'group' ? 'group-hover' : `${parentGroup}-hover`;
    const focusPrefix = parentGroup === 'group' ? 'group-focus-within' : `${parentGroup}-focus-within`;

    return (
    <button
        type="button"
        onClick={(e) => onCopy(value, e)}
        className={clsx(
            'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-transparent text-muted-foreground transition-colors hover:border-border hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            revealOnGroup && `opacity-0 ${hoverPrefix}:opacity-100 ${focusPrefix}:opacity-100`,
            className,
        )}
        aria-label={label ?? `Copy ${value}`}
        title="Copy"
    >
        <Copy className="h-3.5 w-3.5" aria-hidden />
    </button>
    );
};
